const projectNotEmpty = project => project !== undefined && project !== "";

export default projectNotEmpty;
